import classNames from 'clsx';
import React from 'react';

export interface Props {
  className?: string;
  onClick(): void;
  onMouseEnter(): void;
  onMouseLeave(): void;
  onTouchStart(): void;
}

const getClassName = (props: Props) => classNames(props.className);

const PanelDropDownContainer: React.FC<Props> = (props) => (
  <span
    className={getClassName(props)}
    onClick={props.onClick}
    onMouseEnter={props.onMouseEnter}
    onMouseLeave={props.onMouseLeave}
    onTouchStart={props.onTouchStart}
  >
    {props.children}
  </span>
);

export default PanelDropDownContainer;
